export const imageGallerySelector = (state: AppState) => state.imageGallery;
